class Footer {
    constructor(container) {
        this.container = container;
        this.submenuToggles = container.querySelectorAll('.submenu-link');
        this.submenus = container.querySelectorAll('.submenu');
        this.init();
    }

    init() {
        this.handleSubmenuToggle();
        this.handleResize();
    }

    handleSubmenuToggle() {
        this.submenuToggles.forEach(toggle => {
            toggle.addEventListener('click', () => {
                const submenu = toggle.parentElement;
                const submenuList = submenu.querySelector('.submenu-list');
                const plusIcon = submenu.querySelector('.plus-icon');
                const minusIcon = submenu.querySelector('.minus-icon');

                if (window.innerWidth <= 991) {
                    submenu.classList.toggle('open');
                    submenuList.style.display = submenu.classList.contains('open') ? 'flex' : 'none';
                    plusIcon.style.display = submenu.classList.contains('open') ? 'none' : 'inline';
                    minusIcon.style.display = submenu.classList.contains('open') ? 'inline' : 'none';
                } else {
                    submenuList.style.display = 'flex';
                    plusIcon.style.display = 'none';
                    minusIcon.style.display = 'none';
                }
            });
        });
    }

    handleResize() {
        window.addEventListener('resize', () => {
            if (window.innerWidth > 991) {
                // On desktop view, ensure all submenus are visible and icons are hidden
                this.submenus.forEach(submenu => {
                    submenu.querySelector('.submenu-list').style.display = 'flex';
                    submenu.querySelector('.plus-icon').style.display = 'none';
                    submenu.querySelector('.minus-icon').style.display = 'none';
                });
            } else {
                // On mobile view, hide all submenus and show plus icons
                this.submenus.forEach(submenu => {
                    submenu.querySelector('.submenu-list').style.display = 'none';
                    submenu.querySelector('.plus-icon').style.display = 'inline';
                    submenu.querySelector('.minus-icon').style.display = 'none';
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Footer(
        document.querySelector('.footer-menu-content')
    );
});
